var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedicalKitInActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "medical_services"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7424_4909",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7424_4909)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "medical_services_2",
    d: "M2.48431 14.7786C2.13993 14.7786 1.84341 14.6543 1.59474 14.4056C1.34607 14.1569 1.22174 13.8604 1.22174 13.516V5.20443C1.22174 4.85933 1.34607 4.56218 1.59474 4.31299C1.84341 4.06381 2.13993 3.93921 2.48431 3.93921H5.23104V2.38366C5.23104 2.04115 5.35537 1.74509 5.60404 1.49549C5.85271 1.24589 6.14923 1.12109 6.49361 1.12109H9.50641C9.85079 1.12109 10.1473 1.24589 10.396 1.49549C10.6446 1.74509 10.769 2.04115 10.769 2.38366V3.93921H13.5157C13.8608 3.93921 14.158 4.06381 14.4071 4.31299C14.6563 4.56218 14.7809 4.85933 14.7809 5.20443V13.516C14.7809 13.8604 14.6563 14.1569 14.4071 14.4056C14.158 14.6543 13.8608 14.7786 13.5157 14.7786H2.48431ZM2.48431 13.516H13.5157V5.20443H2.48431V13.516ZM6.49361 3.93921H9.50641V2.38366H6.49361V3.93921ZM7.36872 9.99151V11.9915H8.63129V9.99151H10.6313V8.72896H8.63129V6.72896H7.36872V8.72896H5.36872V9.99151H7.36872Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalKitInActive);
export default __webpack_public_path__ + "static/media/medicalKit_InActive.f9f3ca384cf4dc5b1416c369282dfd6b.svg";
export { ForwardRef as ReactComponent };